import { action } from 'typesafe-actions';
// eslint-disable-next-line no-unused-vars
import { StudentInterface, StudentsTypes, StudentsUsersInterface } from './types';

// List Students
export const listStudentsRequest = (payload: object) =>
  action(StudentsTypes.LIST_STUDENTS_REQUEST, payload);
export const listStudentsSuccess = (payload: {
  studentsList: StudentInterface[];
  totalCount: number;
}) => action(StudentsTypes.LIST_STUDENTS_SUCCESS, payload);
export const listStudentsFailure = () =>
  action(StudentsTypes.LIST_STUDENTS_FAILURE);

// Get Student
export const getStudentRequest = (payload: object) =>
  action(StudentsTypes.GET_STUDENT_REQUEST, payload);
export const getStudentSuccess = (payload: { studentData: StudentInterface }) =>
  action(StudentsTypes.GET_STUDENT_SUCCESS, payload);
export const getStudentFailure = () =>
  action(StudentsTypes.GET_STUDENT_FAILURE);

// Create Student
export const createStudentRequest = (payload: object) =>
  action(StudentsTypes.CREATE_STUDENT_REQUEST, payload);
export const createStudentSuccess = () =>
  action(StudentsTypes.CREATE_STUDENT_SUCCESS);
export const createStudentFailure = () =>
  action(StudentsTypes.CREATE_STUDENT_FAILURE);

// Update Student
export const updateStudentRequest = (payload: object) =>
  action(StudentsTypes.UPDATE_STUDENT_REQUEST, payload);
export const updateStudentSuccess = () =>
  action(StudentsTypes.UPDATE_STUDENT_SUCCESS);
export const updateStudentFailure = () =>
  action(StudentsTypes.UPDATE_STUDENT_FAILURE);

// Delete Student
export const deleteStudentRequest = (payload: {
  body: object;
  doNotList?: boolean;
}) => action(StudentsTypes.DELETE_STUDENT_REQUEST, payload);
export const deleteStudentSuccess = () =>
  action(StudentsTypes.DELETE_STUDENT_SUCCESS);
export const deleteStudentFailure = () =>
  action(StudentsTypes.DELETE_STUDENT_FAILURE);

// Create Students
export const createStudentsRequest = (payload: Array<object>) =>
  action(StudentsTypes.CREATE_STUDENTS_REQUEST, payload);
export const createStudentsSuccess = () =>
  action(StudentsTypes.CREATE_STUDENTS_SUCCESS);
export const createStudentsFailure = () =>
  action(StudentsTypes.CREATE_STUDENTS_FAILURE);

// Update Students
export const updateStudentsRequest = (payload: object) =>
  action(StudentsTypes.UPDATE_STUDENTS_REQUEST, payload);
export const updateStudentsSuccess = () =>
  action(StudentsTypes.UPDATE_STUDENTS_SUCCESS);
export const updateStudentsFailure = () =>
  action(StudentsTypes.UPDATE_STUDENTS_FAILURE);

// Delete Students
export const deleteStudentsRequest = (payload: object) =>
  action(StudentsTypes.DELETE_STUDENTS_REQUEST, payload);
export const deleteStudentsSuccess = () =>
  action(StudentsTypes.DELETE_STUDENTS_SUCCESS);
export const deleteStudentsFailure = () =>
  action(StudentsTypes.DELETE_STUDENTS_FAILURE);

// Ckeck Students
export const checkStudentsRequest = (payload: object) =>
  action(StudentsTypes.CHECK_STUDENTS_REQUEST, payload);
export const checkStudentsSuccess = (payload: {
  studentsCheckUsersList: StudentsUsersInterface[];
}) =>
  action(StudentsTypes.CHECK_STUDENTS_SUCCESS, payload);
export const checkStudentsFailure = () =>
  action(StudentsTypes.CHECK_STUDENTS_FAILURE);
